import Vue from 'vue';
import Router from 'vue-router';

import Layout from '@/components/Layout/Layout';

import Login from '@/pages/Login/Login';
import ErrorPage from '@/pages/Error/Error';
import UnderDevelopment from '@/pages/UnderDev/UnderDevelopment';

import { isAuthenticated } from './mixins/auth';
//-------------------------------------- REAL APP
//Admin
import UserManagementPage from '@/routes/admin-management/users/UserManagement';
import CountriesManagementPage from '@/routes/admin-management/countries/CountriesManagement';
import GroupsManagementPage from '@/routes/admin-management/groups/GroupManagement';
import EditGroup from '@/routes/admin-management/groups/EditGroup';
import AddCountry from '@/routes/admin-management/countries/AddCountry';
//
import BadgesPage from '@/routes/badges/Badges';
import AddBadge from '@/routes/badges/AddBadge';
import AwardsPage from '@/routes/awards/Awards';
import BehavioursPage from '@/routes/behaviours/Behaviours';
import AddBehaviour from '@/routes/behaviours/AddBehaviour';
import BehaviourDetailsPage from '@/routes/behaviours/BehaviourDetails';
import ManageBehaviourBadgesPage from '@/routes/behaviours/ManageBadges';
import ManageBehaviourAwardsPage from '@/routes/behaviours/ManageAwards';
import NotificationsPage from '@/routes/notifications/Notifications';
import AddNotification from '@/routes/notifications/AddNotification';
import LeaderboardPage from '@/routes/leaderboard/Leaderboard';
import AddAward from '@/routes/awards/AddAward';

Vue.use(Router);

export default new Router({
  routes: [
    { path: '/', redirect: '/app/content/behaviours' },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/error',
      name: 'Error',
      component: ErrorPage
    },
    {
      path: '/app',
      name: 'Layout',
      component: Layout,
      beforeEnter: (to, from, next) => {
        let token = localStorage.getItem('token');
        isAuthenticated(token) ? next() : next({ path: '/login' });
      },
      children: [
        {
          path: 'under-dev',
          name: 'Under development',
          component: UnderDevelopment
        },
        {
          path: 'content/behaviours',
          name: 'Behaviours',
          component: BehavioursPage
        },
        {
          path: 'content/badges',
          name: 'Badges',
          component: BadgesPage
        },
        {
          path: 'content/badges/create',
          name: 'AddBadge',
          component: AddBadge
        },
        {
          path: 'content/badges/:id',
          name: 'AddBadge',
          component: AddBadge
        },
        {
          path: 'content/awards',
          name: 'Awards',
          component: AwardsPage
        },
        {
          path: 'content/awards/create',
          name: 'AddAward',
          component: AddAward
        },
        {
          path: 'content/awards/:id',
          name: 'AddAward',
          component: AddAward
        },
        {
          path: 'content/behaviours/create',
          name: 'AddBehaviour',
          component: AddBehaviour
        },
        {
          path: 'content/behaviours/:id',
          name: 'AddBehaviour',
          component: AddBehaviour
        },
        {
          path: 'content/behaviours-detail/:id',
          name: 'BehaviourDetail',
          component: BehaviourDetailsPage
        },
        {
          path: 'content/behaviours-detail/:id/badges',
          name: 'ManageBehaviourBadges',
          component: ManageBehaviourBadgesPage
        },
        {
          path: 'content/behaviours-detail/:id/awards',
          name: 'ManageBehaviourAwards',
          component: ManageBehaviourAwardsPage
        },
        {
          path: 'content/notifications',
          name: 'Notifications',
          component: NotificationsPage
        },
        {
          path: 'content/notifications/create',
          name: 'AddNotification',
          component: AddNotification
        },
        {
          path: 'content/notifications/:id',
          name: 'AddNotification',
          component: AddNotification
        },
        {
          path: 'users/leaderboard',
          name: 'Leaderboard',
          component: LeaderboardPage
        },
        // admin
        {
          path: 'admin-console/users',
          name: 'UserManagementPage',
          component: UserManagementPage
        },
        {
          path: 'admin-console/countries',
          name: 'CountriesManagementPage',
          component: CountriesManagementPage
        },
        {
          path: 'admin-console/groups',
          name: 'GroupsManagementPage',
          component: GroupsManagementPage
        },
        {
          path: 'admin-console/groups/:id',
          name: 'EditGroup',
          component: EditGroup
        },
        {
          path: 'admin-console/groups/create',
          name: 'EditGroup',
          component: EditGroup
        },
        {
          path: 'admin-console/countries/create',
          name: 'AddCountry',
          component: AddCountry
        },
        {
          path: 'admin-console/countries/:id',
          name: 'AddCountry',
          component: AddCountry
        }

        // main pages
      ]
    }
  ]
});
